module.exports = __webpack_public_path__ + "static/media/bg_top_navbar@2x.8616aed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/bg/bg_top_navbar@2x.jpg
// module id = 318
// module chunks = 0